export default () => {
    if($('.hero-slider__wrapp').length){
        var $heroSlider = $('.hero-slider__wrapp');

        $heroSlider.slick({
            draggable: true,
            swipe: true,
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnFocus: true,
            arrows: false,
            dots: true,
            customPaging : function(slider, i) {
                return '<button type="button" role="tab"><span>' + $(slider.$slides[i]).find('.hero-slider__slide').attr('data-title') + '</span></button>'; //$(slider.$slides[i]).attr('data-title')
            },
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                      prevArrow: '<button type="button" class="slick-prev"><svg height="30" width="28"><polygon points="22,4 4,16 22,26" class="triangle" /></svg></button>',
                      nextArrow: '<button type="button" class="slick-next"><svg height="30" width="28"><polygon points="4,26 22,16 4,4" class="triangle" /></svg></button>',
                      arrows: true,
                      dots: false,
                    },
                },
            ],
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/_hero-slider.js